<app-key-info [staffMode]="false" storageKeyPrefix="cp-myKeyView-"></app-key-info>